export default __webpack_public_path__ + "static/media/IconPhone.55f7e3bc.png";